import * as React from 'react';
import styled from 'styled-components';
import { getWidth } from '@components/styles';

import ErrorImg from './img/404.jpg';

import Button from '@components/actions/button';
import Typography from '@components/basics/typography';
import { goBack, CallHistoryMethodAction } from 'connected-react-router';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

interface NotFoundPageProps {
  className?: string;
  goBack: () => CallHistoryMethodAction;
}

const ErrorImage = styled.img.attrs({
  src: ErrorImg,
})`
  z-index: 1;
  position: relative;
  width: 100%;

  @media ${({ theme }) => theme.device.tablet} {
    width: ${getWidth(8)};
  }
`;

const ContentWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;

  @media ${({ theme }) => theme.device.tablet} {
    width: auto;
  }
`;

const BackButton = styled(Button).attrs(() => ({
  type: 'button',
  buttonType: 'secondary',
  small: true,
}))``;

const BackButtonContainer = styled.div`
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translate(-50%, 0);
`;

const ErrorTypography = styled(Typography)`
  color: ${({ theme }) => theme.colors.error};
`;

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goBack: () => dispatch(goBack()),
});

const NotFoundPage: React.FC<NotFoundPageProps> = (props) => (
  <section className={props.className}>
    <ContentWrapper>
      <ErrorTypography type="super" className="error-text">
        We couldn’t find the page
      </ErrorTypography>
      <ErrorImage />
      <ErrorTypography type="super" className="error-text">
        you are looking for.
      </ErrorTypography>
      <ErrorTypography type="super" className="error-text mobile">
        We couldn’t find the page you are looking for.
      </ErrorTypography>
    </ContentWrapper>
    <BackButtonContainer>
      <BackButton onClick={() => props.goBack()}>Go back</BackButton>
    </BackButtonContainer>
  </section>
);

export default connect(
  null,
  mapDispatchToProps
)(styled(NotFoundPage)`
  height: calc(100vh - 100px);

  .error-text {
    width: 100%;
    width: 100vw;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    display: none;

    @media ${({ theme }) => theme.device.laptop} {
      width: ${getWidth(24)};
      display: block;
    }

    &:first-child {
      bottom: 42%;
      z-index: 2;
    }

    &:nth-last-child(2) {
      top: 58%;
      z-index: 2;
      @media ${({ theme }) => theme.device.laptop} {
        z-index: 0;
      }
    }

    &.mobile {
      display: block;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      @media ${({ theme }) => theme.device.laptop} {
        display: none;
      }
    }
  }
`);
